import { render, staticRenderFns } from "./flightChangeInfos.vue?vue&type=template&id=146e95dd&scoped=true&"
import script from "./flightChangeInfos.vue?vue&type=script&lang=ts&"
export * from "./flightChangeInfos.vue?vue&type=script&lang=ts&"
import style0 from "./flightChangeInfos.vue?vue&type=style&index=0&id=146e95dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e95dd",
  null
  
)

export default component.exports